import ReactDOM from "react-dom";
import { MDBAutocomplete, MDBBtn, MDBCheckbox, MDBIcon, MDBInput, MDBModalFooter, MDBSelect } from 'mdb-react-ui-kit';
import React, { forwardRef, useEffect, useMemo, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { createLunaProfile, externalNumberearch, getMisc } from '../../../apiclients/streamsapi_bridge';
import Voice1 from "../../../uimedia/lunavoices/Alloy_aka_Luna_tts-1-hd.mp3"
import Voice2 from "../../../uimedia/lunavoices/Echo_aka_Eric_tts-1-hd.mp3"
import Voice3 from "../../../uimedia/lunavoices/Ash_aka_Oscar_tts-1-hd.mp3"
import Voice4 from "../../../uimedia/lunavoices/Shimmer_aka_Serena_tts-1-hd.mp3"
import { validatePhoneNumber } from "../phonenumbers/AddRemoveNumbers";
import { customSearch } from "../../../components/CustomSearchUtil/CustomSearch";
const defaultData = ['One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight'];

const AddLuna = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    const [data, setData] = useState(defaultData);
    const [checkAvailbility, setCheckAvailbility] = useState(false);
    const [allLocations, setAllLocations] = useState([]);
    const [operators, setoperators] = useState([]);
    const [displayValue, setdisplayValue] = useState([]);
    const navigate = useNavigate();
    const [destinationValue, setDestinationValue] = useState("");
    const [updateDest, setUpdateDest] = useState({});
    const [isUpdateDest, setIsUpdateDest] = useState(false);
    const [externError, setExternError] = useState([]);
    const voices = [
        { voiceid: 1, voiceurl: Voice1, title: "Luna" },
        { voiceid: 2, voiceurl: Voice2, title: "Eric" },
        { voiceid: 3, voiceurl: Voice3, title: "Oscar" },
        { voiceid: 4, voiceurl: Voice4, title: "Serena" }
    ];

    const [displayLunaVoices, setdisplayLunaVoices] = useState(voices);
    const [lunaVoices, setlunaVoices] = useState(voices);
    const [voiceValue, setvoiceValue] = useState("Luna");
    const [userList, setuserList] = useState([]);
    const [callerIDList, setcallerIDList] = useState([]);
    const [hgList, sethgList] = useState([]);
    const [acdList, setacdList] = useState([]);
    const [hopDisplayedOptions, setHopDisplayedOptions] = useState([]);
    const [hopSearchError, setHopSearchError] = useState("");
    const typingTimerRef = useRef(null);
    const hopDisplayedOptionsRef = useRef([]);

    const { register, watch, setValue, handleSubmit, formState: { errors, isDirty, dirtyFields }, setError, clearErrors, control } = useForm({
        defaultValues: {
            name: "",
            extension: "",
            location_id: "",
            hop: {
                title: "",
                val: "",
                uniqueid: "",
                cid_pass: "",
                cid_pass_flag: true,
                hop_type: 0,
            },
            voice_type: 1,
        }
    });

    async function fetchData() {
        console.log(sessionStorage.getItem("admin_session"));
        const response = await getMisc(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            {
                misc: ["hopmisc", "all_locations", "callerid_list"],
            }
        );
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const tdata = await response.json();
        if (!tdata) {
            window.alert(`info with id  not found`);
            navigate("/");
        }
        console.log("tdata :::::::::::::: " + JSON.stringify(tdata));
        setAllLocations(tdata?.misc?.all_locations ?? []);
        let users = tdata?.misc?.hopmisc?.user ?? [];
        let group = tdata?.misc?.hopmisc?.hg ?? [];
        const mergeWithSortList = [
            ...users,
            ...group,
        ].sort((a, b) => a?.title?.localeCompare(b?.title));

        setoperators(mergeWithSortList);
        setdisplayValue(mergeWithSortList);
        setuserList((tdata?.misc?.hopmisc?.user ?? []).sort((a, b) => a?.title?.localeCompare(b?.title)));
        sethgList((tdata?.misc?.hopmisc?.hg ?? []).sort((a, b) => a?.title?.localeCompare(b?.title)));
        setacdList((tdata?.misc?.hopmisc?.acd ?? []).sort((a, b) => a?.title?.localeCompare(b?.title)));
        setcallerIDList(tdata?.misc?.callerid_list ?? []);


    }

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        return () => clearTimeout(typingTimerRef.current);
    }, []);
const searchDID = async (number, isExternalInput = false) => {
    try {
        const siteid = JSON.parse(
            sessionStorage.getItem("admin_session")
        ).siteid;
        const resp = await externalNumberearch(siteid, number);
        const data = await resp.json();
        if (data.status === "success") {
            if (data.routing_obj) {
                const linked = data.routing_obj;

                if (isExternalInput) {
                    setExternError([
                        "This is an internal number. Please provide an external number."
                    ]);

                    setValue("hop.val", number, { shouldDirty: true });

                } else {
                    if (!linked.luna_hop_valid) {
                        setHopSearchError("This is an internal number. Please enter an internal number assigned to User/Hunt Group.");
                        return;
                    }
                    const linkedItem = {
                        ...linked,
                        title: linked.title ?? number,
                        extensions: linked.extensions ?? number,
                        category: linked.category ?? "",
                        _label: `${linked.extensions ? linked.extensions + " : " : ""}${linked.title ?? number}${linked.category ? " : " + linked.category : ""}`,
                        _fromDID: true,
                    };

                    setHopDisplayedOptions((prev) => {
                        const withoutOld = prev.filter((i) => !i._fromDID);
                        return [withoutOld[0], linkedItem, ...withoutOld.slice(1)];
                    });
                }

            } else {
                if (isExternalInput) {
                    setExternError([]); // clear if not linked
                }
            }

        } else {
            const msgs = data.message?.errors ?? [];

            if (isExternalInput) {
                if (msgs.length > 0) {
                    setExternError([msgs[0].is_internal_did ? "This is an internal number. Please provide an external number." : msgs[0].message]);
                } else {
                    setExternError([]); //  clear
                }
            } else {
                if (msgs.length > 0) {
                    setHopSearchError(msgs[0].is_internal_did ? "This is an internal number. Please enter an internal number assigned to User/Hunt Group." : msgs[0].message);
                }
            }
        }
    } catch (err) {
        console.error("DID search error:", err);
    }
};
    async function checkAvailability(e) {

        console.log(sessionStorage.getItem("admin_session"));
        const response = await getMisc(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            { check_ext: parseInt(e.target.value) }
        );
        console.log(response);
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const tdata = await response.json();
        if (!tdata) {
            window.alert(`info with id  not found`);
            navigate("/");
        }
        if (tdata.check_ext) {
            setCheckAvailbility(true);
            setError("extension", { message: "Extension is available" });
        } else {
            setCheckAvailbility(false);
            setError("extension", { message: "Extension is not available" });
        }
        console.log(tdata);
    }

    // async function validateOperator() {
    //     // const operator = watch("hop");
    //     if (!selectedType) {
    //         setError("hop", { message: "Human Operator should not be empty" });
    //     }
    // }

    const onsubmit = async (data) => {

        let updates = {};
        if (isDirty) {
            const modifiedData = {};
            const operatorDataJSon = data.hop;
            const operatorFieldJson = dirtyFields.hop;
            for (const field of Object.keys(operatorFieldJson)) {
                if (operatorFieldJson[field] && operatorDataJSon.hasOwnProperty(field)) {
                    if (field === "val") {
                        modifiedData[field] = parseInt(operatorDataJSon[field]);
                    } else {
                        modifiedData[field] = operatorDataJSon[field];
                    }
                }
            }
            if (modifiedData) {
                updates = {
                    reqid: 142,
                    name: data.name,
                    extension: parseInt(data.extension),
                    siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                    location_id: (data?.location_id && data?.location_id !== "") ? parseInt(data?.location_id) : "",
                    hop: modifiedData,

                    voice_type: parseInt(data.voice_type),
                };
            }
        }
        setCheckAvailbility(false);
        //alert(JSON.stringify(updates))
        console.log("JSON Create Luna:: " + JSON.stringify(updates));
        props.setIsloading(true);
        let saverep = await createLunaProfile(updates);
        console.log(`reponse of add Luna :::: ${JSON.stringify(saverep)}`);
        let saverepeMsg = await saverep.json();
        console.log(`reponse of add Luna after:::: ${JSON.stringify(saverepeMsg)}`);
        setTimeout(() => {
            props.setIsloading(false);
        }, 2000);
        if (saverepeMsg.status && saverepeMsg.status == "success") {
            localStorage.setItem("s_message", saverepeMsg.message);
            // window.location.href = "/luna-landing"
            props.onClose();
            navigate("/luna-landing");
            window.location.reload();


        } else {
            setCheckAvailbility(false);
            if (saverepeMsg.message?.errors) {
                saverepeMsg.message.errors.forEach((err) => {
                    setError(err.param_name, {
                        type: "server",
                        message: err.message,
                    });

                    const fieldElement = document.querySelector(
                        `input[name="${err.param_name}"]`
                    );
                    if (fieldElement) {
                        fieldElement.focus();
                        fieldElement.scrollIntoView({ behavior: "smooth" });
                    }
                });

            } else {
                localStorage.setItem("f_message", saverepeMsg.message);
                // window.location.href = "/luna-landing"
                props.onClose();
                navigate("/luna-landing");
                window.location.reload();
            }

        }
    }

    const audioRef = useRef(null); // Ref to the audio element
    const [isPlaying, setIsPlaying] = useState(false); // To track if the audio is playing
    const [playVoiceId, setplayVoiceId] = useState("");

    const handlePlayAudio = (e, audioUrl, voiceid) => {
        e.preventDefault();
        e.stopPropagation();
        setplayVoiceId(voiceid);
        if (audioRef.current) {
            audioRef.current.pause(); // Pause the audio
            audioRef.current.currentTime = 0; // Reset to the start
            setIsPlaying(false); // Update the state
        }

        // Set the new audio source and play it
        if (audioRef.current) {
            audioRef.current.src = audioUrl;
            audioRef.current.play();
            setIsPlaying(true); // Update the state to reflect audio is playing
        }
    };

    const handlePauseAudio = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            setIsPlaying(false);
            setplayVoiceId("");
        }

    }

    function handleVoiceSelect(value) {

        setvoiceValue(value);
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            setIsPlaying(false);
        }
        setplayVoiceId("");
        const voice = voices.find(v => v.title === value);

        if (voice) {
            setValue("voice_type", parseInt(voice.voiceid), { shouldDirty: true });
        }
    }

    const operatorType =
        { "Users": 2, "Hunt Groups": 1, "Call Queues": 4, "External Numbers": 3 }

    const dummyData = {
        Users: userList,
        "Hunt Groups": hgList,
        "Call Queues": acdList,
        // "ACD Queues": ["Queue 1", "Queue 2", "Queue 3"],
        "External Numbers": [],
        // "Search DID": ['987654321', '1234567890', '9876543210'],
    };

    const [selectedType, setSelectedType] = useState(null);
    const [selectedValue, setSelectedValue] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0, width: 0 });


    const dropdownRef = useRef();
    const portalDropdownRef = useRef(null);


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target) &&
                portalDropdownRef.current &&
                !portalDropdownRef.current.contains(event.target)
            ) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);


    const handleMainTypeClick = (e, type, typeid) => {
        e.preventDefault();
        e.stopPropagation();
        console.log("Selected Type:", type);
        setSelectedType(type);

        // Close dropdown if the type has no options
        if (dummyData[type].length === 0) {
            setSelectedValue(type);
            setIsDropdownOpen(false);
        } else {
            setSearchTerm("");
        }
        setValue("hop.hop_type", typeid, { shouldDirty: true });
    };


    const handleBack = () => {
        setSelectedType(null);
        setSearchTerm("");
    };

    const handleClear = (e) => {
        e.stopPropagation();
        setSelectedValue(null);
        setSelectedType(null);
        setSearchTerm("");
        setIsDropdownOpen(true);
        setValue("hop.hop_type", 0, { shouldDirty: true });
        setValue("hop.val", "", { shouldDirty: true });
        setValue("hop.uniqueid", "", { shouldDirty: true });
        setValue("hop.cid_pass_flag", true, { shouldDirty: true });
        setValue("hop.cid_pass", "", { shouldDirty: true });
        setValue("hop.title", "", { shouldDirty: true });
    };

    const [typingTimeout, setTypingTimeout] = useState(null);
    useEffect(() => {
        return () => {
            if (typingTimeout) {
                clearTimeout(typingTimeout);
            }
        };
    }, [typingTimeout]);

    // const sendApIRequest = async (searchValue, filteredData) => {
    //     try {
    //         if (searchValue.trim() !== "") {
    //             // let update = {
    //             //     ph_num: searchValue,
    //             //     siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
    //             // }
    //             // console.log("Request for the search :::::: " + JSON.stringify(update));
    //             const serverResponse = await externalNumberearch(JSON.parse(sessionStorage.getItem("admin_session")).siteid, searchValue);
    //             const responseData = await serverResponse.json();
    //             console.log("Response for the search :::::: " + JSON.stringify(responseData));
    //             if (!responseData.status || responseData.status !== "success") {
    //                 if (responseData.message?.errors) {
    //                     responseData.message.errors.forEach((err) => {

    //                             setError(busynoanswerfield, {
    //                                 type: "server",
    //                                 message: err.message,
    //                             });

    //                     });
    //                     setDisplayedValue([]);
    //                 }

    //             }
    //             else {
    //                 console.log("reponse for the data ::::::::::::::: " + JSON.stringify(responseData));
    //                 if (responseData.routing_obj) {
    //                     const newValue = { ...responseData.routing_obj, title: responseData?.routing_obj?.title ?? "", extensions: responseData?.routing_obj?.extensions ?? "" }
    //                     const updatedDefaultData = [...filteredData, newValue];
    //                     setDisplayedValue(updatedDefaultData);
    //                     if (!innerFlag) {
    //                         clearErrors(busynoanswerfield);
    //                         setIsExternal(false);
    //                     } else {
    //                         clearErrors(routeTimeoutField);
    //                         setisInternalDID(false);
    //                     }
    //                 } else {


    //                     if (!innerFlag) {
    //                         clearErrors(busynoanswerfield);
    //                         setIsExternal(true);

    //                         const newValue = { title: searchValue };
    //                         const updatedDefaultData = [...filteredData, newValue];
    //                         setDisplayedValue(updatedDefaultData);
    //                         console.log("setDisplayedValue", setDisplayedValue(updatedDefaultData))
    //                     } else {
    //                         setisInternalDID(false);
    //                         setError(routeTimeoutField, {
    //                             type: "server",
    //                             message: "Please provide a valid internal number.",
    //                         });
    //                     }
    //                 }

    //             }

    //         }

    //     } catch (error) {
    //         console.log(`Error in sendApIRequest for address search :::: ${error}`);

    //     }

    // }

    let filteredOptions =
        selectedType
            ? customSearch(
                dummyData[selectedType],
                searchTerm,
                ["title", "extensions"] // search in both title and extensions
            )
            : [];

    // if (filteredOptions.length === 0 && selectedType) {
    //     const lowercasedValue = searchTerm.toLowerCase();
    //     if (lowercasedValue.length > 9 && lowercasedValue.length < 12) {
    //         if (typingTimeout) {
    //             clearTimeout(typingTimeout);
    //         }
    //         const newTimeout = setTimeout(() => {
    //             sendApIRequest(lowercasedValue, filteredOptions);
    //         }, 500);
    //         // Update the typingTimeout state with the new timeout
    //         setTypingTimeout(newTimeout);

    //     }
    // }


    useEffect(() => {
        if (isDropdownOpen && dropdownRef.current) {
            const rect = dropdownRef.current.getBoundingClientRect();
            setDropdownPosition({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX,
                width: rect.width,
            });
        }
    }, [isDropdownOpen]);

    const handleOperatorSelect = (item) => {
        setSelectedValue(item.title + "" + (item.extensions ? ` : ${item.extensions}` : ""));
        setIsDropdownOpen(false);
        const { id, code } = item;
        setValue("hop.hop_type", id ? 2 : operatorType[selectedType], { shouldDirty: true });
        setValue("hop.val", id ?? code, { shouldDirty: true });
        clearErrors("hop.hop_type");
    }

    // ── NEW RouteCalls-style Human Operator ──────────────────────────────────

    const CREATE_HOP_EXTERNAL_LABEL = "Add External Number";
    const MAX_HOP_RESULTS = 10;

    const [hopMainValue, setHopMainValue] = useState("");
    const [isHopExternal, setIsHopExternal] = useState(false);
    useEffect(() => {
        hopDisplayedOptionsRef.current = hopDisplayedOptions;
    }, [hopDisplayedOptions]);


    // Unified sorted list: Users + Hunt Groups + Call Queues
    const hopFullList = useMemo(() => [
        ...userList.map((u) => ({ ...u, category: "User" })),
        ...hgList.map((g) => ({ ...g, category: "Hunt Group" })),
        ...acdList.map((a) => ({ ...a, category: "Call Queue" })),
    // Sort by extension number ascending; items without an extension fall to the end (Infinity)
    ].sort((a, b) => (a?.extensions ?? Infinity) - (b?.extensions ?? Infinity)), [userList, hgList, acdList]);

    const hopItemLabel = (item) => {
        if (!item) return "";
        const ext = item.extensions ? `${item.extensions} : ` : "";
        const cat = item.category ? ` : ${item.category}` : "";
        return `${ext}${item.title}${cat}`;
    };

    const buildHopDefaultDisplay = () => [
        { title: CREATE_HOP_EXTERNAL_LABEL, _isExternal: true },
    ];

    useEffect(() => {
        setHopDisplayedOptions(buildHopDefaultDisplay());
    }, [hopFullList]);

    const onHopSearch = (raw) => {
    const term = (raw ?? "").toLowerCase().trim();
    if (!term) {
        setHopSearchError("");
        setHopDisplayedOptions(buildHopDefaultDisplay());
        return;
    }
    setHopSearchError("");

    const matched = hopFullList
        .filter(
            (item) =>
                item.title?.toLowerCase().includes(term) ||
                item.extensions?.toString().includes(term)
        )
        .slice(0, MAX_HOP_RESULTS);
    const results = [
        { title: CREATE_HOP_EXTERNAL_LABEL, _isExternal: true },
        ...matched,
    ];
    setHopDisplayedOptions(results);
    const digits = term.replace(/\D/g, "");
    if (digits.length >= 10 && digits.length <= 11) {
        clearTimeout(typingTimerRef.current);
        typingTimerRef.current = setTimeout(() => {
            searchDID(digits, false);
        }, 500);
    }
};

    const onHopSelect = (selectedLabel) => {
    if (!selectedLabel) return;
    if (selectedLabel === CREATE_HOP_EXTERNAL_LABEL) {
        setIsHopExternal(true);
        setHopMainValue(CREATE_HOP_EXTERNAL_LABEL);
        clearErrors("hop.hop_type");
        setValue("hop.hop_type", 3, { shouldDirty: true });
        setValue("hop.val", "", { shouldDirty: true });
        setValue("hop.uniqueid", "", { shouldDirty: true });
        return;
    }
    setIsHopExternal(false);
    setHopMainValue(selectedLabel);
    clearErrors("hop.hop_type");
    let item = hopFullList.find((i) => hopItemLabel(i) === selectedLabel);
    //  ADD THIS (DID fallback)
    if (!item) {
        item = hopDisplayedOptionsRef.current.find(
            (i) =>
                i._fromDID &&
                (i._label === selectedLabel || hopItemLabel(i) === selectedLabel)
        );
    }

    if (item) {
        const { id, code } = item;
        const hopType = item.category === "User"
            ? 2
            : item.category === "Hunt Group"
            ? 1
            : 4;
        let rawValue = id ?? code;
        // _fromDID User items don't carry id — look up the real id from hopFullList
        if (!rawValue && item._fromDID) {
            const match = hopFullList.find(
                (i) => String(i.extensions) === String(item.extensions) && i.category === item.category
            );
            rawValue = match?.id ?? match?.code;
        }
        const numericValue = rawValue ? Number(rawValue) : "";
        setValue("hop.hop_type", hopType, { shouldDirty: true });
        setValue("hop.val", numericValue, { shouldDirty: true });
    }
};

    return (
        <>
            <audio ref={audioRef} />

            <div>
                <div className="tel-numbers">
                    <strong>{t("Luna Name")}</strong>
                </div>
                <form>
                    <div className="form pt-1">
                        <input
                            type="text"
                            maxLength={50}
                            className="form-control"
                            {...register("name", { required: "Name should not be empty" })}
                        />
                        {errors.name && (
                            <p className="text-danger">{errors.name.message}</p>
                        )}
                    </div>
                    <div>
                        <div className="pt-2">
                            <div className="tel-numbers mt-3">
                                <strong>{t("extension")}</strong>
                            </div>

                            <input
                                type="text"
                                className="form-control w-100"
                                maxLength={5}
                                onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                    }
                                }}
                                {...register("extension", {
                                    required: "Extension is required",
                                    minLength: {
                                        value: 3,
                                        message: 'Extension must be at least 3 characters',
                                    },
                                    maxLength: {
                                        value: 5,
                                        message: 'Extension must not exceed 5 characters',
                                    },
                                })}
                                onChange={(e) => {
                                    e.preventDefault();
                                    if (!/^\d+$/.test(e.target.value)) {
                                        setCheckAvailbility(false);
                                        setError("extension", { message: "Extension is required and must be numeric" });
                                    } else if (+e.target.value > 9989 && +e.target.value <= 9999) {
                                        setCheckAvailbility(false);
                                        setError("extension", {
                                            message: "Select an extension in the range of 100 to 9989 or 10000 to 99999."
                                        });
                                    }
                                    else if (e.target.value.length >= 3 && e.target.value.length <= 5) {
                                        if (/^0{3,}/.test(e.target.value)) {
                                            setCheckAvailbility(false);
                                            setError("extension", { message: "An extension cannot begin with zero(0)" });
                                        } else {
                                            checkAvailability(e);
                                        }
                                    } else {
                                        setCheckAvailbility(false);
                                        clearErrors("extension");
                                    }
                                }}
                            />
                            {errors.extension && (
                                <>
                                    {!checkAvailbility && (
                                        <>
                                            <p className="text-danger">
                                                {errors.extension.message}
                                            </p>
                                        </>
                                    )}

                                    {checkAvailbility && (
                                        <p style={{ color: "Green" }} className="clr-red">
                                            {errors.extension.message}
                                        </p>
                                    )}
                                </>
                            )}

                        </div>
                    </div>


                    <div className="tel-numbers mt-3">
                        <strong>{t("location")}</strong>
                    </div>

                    <div className="phoneselect">
                        <select className="form-control form-select selectname" name="San Jose"
                            {...register("location_id", { required: "Location should not be empty" })}
                        >
                            <option value="">--- Select Location ---</option>
                            {allLocations?.length > 0 && allLocations?.map((loc) => (
                                <option value={loc.loc_id}>{loc.loc_name}</option>
                            ))}
                        </select>
                        {errors.location_id && (
                            <p className="text-danger">{errors.location_id.message}</p>
                        )}
                    </div>


                    <div className="tel-numbers mt-3">
                        <strong>Voice</strong>
                    </div>
                    <MDBAutocomplete
                        data={displayLunaVoices}
                        placeholder='Select Voice'
                        displayValue={(row) => row.title}
                        value={voiceValue}
                        // onSearch={onCustomSearch} 
                        onSelect={(value) => handleVoiceSelect(value)}
                        itemContent={(result) => (
                            <div className='autocomplete-custom-item-content w-100'>
                                <div className='d-flex align-items-center w-100'>
                                    <div className='autocomplete-custom-item-title w-40'>{result.title}</div>
                                    <MDBIcon
                                        far
                                        icon={playVoiceId === result.voiceid ? "pause-circle" : "play-circle"}
                                        className='ms-2'
                                        size='lg'
                                        color='primary'
                                        onClick={(e) => {
                                            if (playVoiceId === result.voiceid) {
                                                handlePauseAudio(e);
                                            } else {
                                                handlePlayAudio(e, result.voiceurl, result.voiceid);
                                            }
                                        }
                                        }
                                    />
                                </div>
                            </div>
                        )}
                    />



                    <div className="tel-numbers mt-3">
                        <strong>Human Operator</strong>
                    </div>
                    {/* OLD Human Operator – categorised custom dropdown. Preserved via false &&. */}
                    {false && (
                        <>
                            <Controller
                                name="hop.hop_type"
                                control={control}
                                rules={{
                                    validate: (value) => {
                                        if (!value || value.hop_type === 0 || !selectedValue) {
                                            return "Human Operator is required";
                                        }
                                        return true;
                                    }
                                }} render={({ field }) => (
                                    <>


                                        <div className="custom-selector w-100" ref={dropdownRef}>
                                            <div
                                                className="custom-selector-box form-select position-relative"
                                                onClick={(e) => {
                                                    clearErrors("hop.hop_type");
                                                    setSelectedValue(null);
                                                    setSelectedType(null);
                                                    setSearchTerm("");
                                                    setIsDropdownOpen(!isDropdownOpen);
                                                }}
                                            >
                                                {selectedValue || "Select Human Operator"}
                                            </div>
                                            {isDropdownOpen &&
                                                ReactDOM.createPortal(
                                                    <div
                                                        className="custom-selector-dropdown"
                                                        ref={portalDropdownRef}
                                                        style={{
                                                            top: dropdownPosition.top,
                                                            left: dropdownPosition.left,
                                                            width: dropdownPosition.width,
                                                            zIndex: 9999,
                                                        }}
                                                    >
                                                        <div className="custom-selector-dropdown">
                                                            {!selectedType ? (
                                                                <div className="custom-selector-options">
                                                                    {Object.keys(dummyData).map((type) => (
                                                                        <div
                                                                            key={type}
                                                                            className="custom-selector-option"
                                                                            onClick={(e) => {
                                                                                field.onChange(operatorType[type]);
                                                                                handleMainTypeClick(e, type, operatorType[type]);
                                                                            }}
                                                                        >
                                                                            {type}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    {operatorType[selectedType] && operatorType[selectedType] !== 3 && (
                                                                        <div className="custom-selector-suboptions">
                                                                            <div className="top-bar">
                                                                                <input
                                                                                    type="text"
                                                                                    autoFocus
                                                                                    placeholder={`Search ${selectedType}`}
                                                                                    value={searchTerm}
                                                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                                                />
                                                                                {searchTerm && (
                                                                                    <MDBIcon fas icon="times" className="px-2 close-icon" color="danger" onClick={() => setSearchTerm("")} />
                                                                                )}
                                                                            </div>
                                                                            <div className="suboptions-list">
                                                                                {filteredOptions.length > 0 ? (
                                                                                    filteredOptions.map((item) => (
                                                                                        <div
                                                                                            key={item.extensions}
                                                                                            className="custom-selector-option"
                                                                                            onClick={() => handleOperatorSelect(item)}
                                                                                        >
                                                                                            {item.title}{item.extensions ? ` : ${item.extensions}` : ""}
                                                                                        </div>
                                                                                    ))
                                                                                ) : (
                                                                                    <div className="custom-selector-option">No results found</div>
                                                                                )}
                                                                            </div>
                                                                            <MDBModalFooter className="py-2 pe-2">
                                                                                <MDBBtn size="sm" className="back-btn" onClick={handleBack}>Back</MDBBtn>
                                                                            </MDBModalFooter>
                                                                        </div>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>,
                                                    document.body
                                                )}
                                        </div>
                                        {errors?.hop?.hop_type && (
                                            <p className="text-danger">{errors?.hop?.hop_type.message}</p>
                                        )}
                                    </>
                                )}
                            />
                            {selectedType === "External Numbers" && dummyData["External Numbers"].length === 0 && (
                                <div className="mt-3">
                                    <MDBInput type="text" placeholder="Enter Name" {...register("hop.name", { required: "Name should not be empty" })} />
                                    {errors?.hop?.name && <p className="text-danger">{errors.hop.name.message}</p>}
                                    <MDBInput type="text" className="mt-3" placeholder="Enter External Number" {...register("hop.val", { onChange: (e) => setValue("hop.uniqueid", e.target.value, { shouldDirty: true }), validate: validatePhoneNumber, required: "External Number should not be empty" })} />
                                    {errors?.hop?.val && <p className="text-danger">{errors.hop.val.message}</p>}
                                    <div className="d-flex align-items-center justify-content-between mt-2">
                                        <label htmlFor="CheckBox1" className="fw-bold">Caller ID Pass Through</label>
                                        <MDBCheckbox name="CheckBox1" id="CheckBox1" checked={watch("hop.cid_pass_flag")} onChange={(e) => {setValue("hop.cid_pass_flag", e.target.checked, { shouldDirty: true });
                                        if (e.target.checked) {
                                             clearErrors("hop.cid_pass")
                                             }}} />
                                    </div>
                                    <Controller
                                        name="hop.cid_pass"
                                        control={control}
                                        rules={{
                                            validate: (value) => {
                                                if (watch("hop.cid_pass_flag")) return true;
                                                return validatePhoneNumber(value) || "Caller ID is required";
                                            }
                                        }}
                                        render={({ field }) => (
                                            <>
                                                <MDBSelect
                                                    disabled={watch("hop.cid_pass_flag")}
                                                    name="hop.cid_pass"
                                                    value={field.value}
                                                    search
                                                    onChange={(e) => {
                                                        field.onChange(e.value);
                                                        setValue("hop.cid_pass", e.value, { shouldDirty: true });
                                                    }}
                                                    data={[{ value: "", text: "Choose Caller ID" }, ...(callerIDList?.map((item) => ({ value: item.phnum, text: item.addl_info })))]}
                                                />
                                                {errors?.hop?.cid_pass && <p className="text-danger">{errors.hop.cid_pass.message}</p>}
                                            </>
                                        )}
                                    />
                                </div>
                            )}
                        </>
                    )}

                    {/* ── NEW RouteCalls-style Human Operator ── */}
                    <Controller
                        name="hop.hop_type"
                        control={control}
                        rules={{
                            validate: (value) => {
                                if (!value || value === 0 || !hopMainValue) {
                                    return "Human Operator is required";
                                }
                                return true;
                            }
                        }}
                        render={() => (
                            <>
                                <div className="position-relative w-100 routing-input">
                                    <MDBAutocomplete
                                        placeholder="Search and Select Human Operator"
                                        data={hopDisplayedOptions}
                                        value={hopMainValue}
                                        title={hopMainValue}
                                        displayValue={(item) => item._isExternal ? item.title : hopItemLabel(item)}
                                        onChange={(val) => {
                                            setHopMainValue(val);
                                            if (val === "") {
                                                setIsHopExternal(false);
                                                clearErrors("hop.hop_type");
                                                setHopSearchError("");
                                                setHopDisplayedOptions(buildHopDefaultDisplay());
                                            }
                                        }}
                                        onSelect={onHopSelect}
                                        onSearch={onHopSearch}
                                        onClick={(e) => e.target.select()}
                                        itemContent={(item) => (
                                            <div className="d-flex justify-content-between align-items-center w-100">
                                                <span>{item._isExternal ? item.title : hopItemLabel(item)}</span>
                                                {item._isExternal &&
                                                    <MDBIcon fas icon="plus" size="md" color="primary" />
                                                }
                                            </div>
                                        )}
                                    />
                                    {/* <div className="routing-clear-icon" style={{ transform: "translate(-2px, -48%)" }} onClick={() => {
                                        setHopMainValue("");
                                        setIsHopExternal(false);
                                        clearErrors("hop.hop_type");
                                        setHopDisplayedOptions(buildHopDefaultDisplay());
                                    }}>
                                        <MDBIcon
                                            fas
                                            icon="times" />
                                    </div> */}
                                </div>
                                {errors?.hop?.hop_type && (
                                    <p className="text-danger">{errors?.hop?.hop_type.message}</p>
                                )}
                                {hopSearchError && (
                                    <p className="text-danger">{hopSearchError}</p>
                                )}
                            </>
                        )}
                    />

                    {/* External Number fields – same logic as existing AddLuna Human Operator */}
                    {isHopExternal && (
                        <div className="mt-3">
                            <MDBInput type="text" placeholder="Enter Name" {...register("hop.name", { required: "Name should not be empty" })} />
                            {errors?.hop?.name && <p className="text-danger">{errors.hop.name.message}</p>}
                            <MDBInput type="text" className="mt-3" placeholder="Enter External Number" 
                                {...register("hop.val", {
                                    required: "External Number should not be empty",
                                    validate: validatePhoneNumber,
                                    onChange: (e) => {
                                        setValue("hop.uniqueid", e.target.value, { shouldDirty: true });
                                        const raw = e.target.value;
                                        const digits = raw.replace(/\D/g, "");
                                        if (externError?.length) {
                                            setExternError([]);
                                        }

                                        if (digits.length >= 10 && digits.length <= 11) {
                                            clearTimeout(typingTimerRef.current);

                                            typingTimerRef.current = setTimeout(() => {
                                                searchDID(digits, true);
                                            }, 500);
                                        }
                                    }
                                })}
                            />
                            {errors?.hop?.val && <p className="text-danger">{errors.hop.val.message}</p>}
                            {externError?.length > 0 && (
                                <p className="text-danger">{externError[0]}</p>
                            )}
                            <div className="d-flex align-items-center justify-content-between mt-2">
                                <label htmlFor="CheckBox1" className="fw-bold">Caller ID Pass Through</label>
                                <MDBCheckbox name="CheckBox1" id="CheckBox1" checked={watch("hop.cid_pass_flag")} onChange={(e) => {setValue("hop.cid_pass_flag", e.target.checked, { shouldDirty: true })
                                    if (e.target.checked) {
                                        clearErrors("hop.cid_pass");
                                    }
                            } }/>
                            </div>
                            <Controller
                                name="hop.cid_pass"
                                control={control}
                                rules={{
                                    validate: (value) => {
                                        if (watch("hop.cid_pass_flag")) return true;
                                        if (!value || value === "") return "Caller ID is required";
                                        return validatePhoneNumber(value);
                                    }
                                }}
                                render={({ field }) => (
                                    <>
                                        <MDBSelect
                                            disabled={watch("hop.cid_pass_flag")}
                                            name="hop.cid_pass"
                                            value={field.value}
                                            search
                                            onChange={(e) => {
                                                field.onChange(e.value);
                                                setValue("hop.cid_pass", e.value, { shouldDirty: true });
                                            }}
                                            data={[{ value: "", text: "Choose Caller ID" }, ...(callerIDList?.map((item) => ({ value: item.phnum, text: item.addl_info })))]}
                                        />
                                        {errors?.hop?.cid_pass && <p className="text-danger">{errors.hop.cid_pass.message}</p>}
                                    </>
                                )}
                            />
                        </div>
                    )}
                    <div>
                        <p className="text-secondary pt-2 mt-2">
                            <span className="green-text">Luna AI Receptionist </span>
                            will be purchased.
                        </p>
                        <p className="text-secondary lh-sm mb-3 mt-2">
                            This will increase your bill by
                            <span className="green-text"> $10 </span>

                            per month plus
                            <span className="green-text"> $.20 </span>

                            per minute from the time the call gets answered to the time the call gets transferred.
                        </p>
                    </div>


                    {/* <p className="text-secondary pt-2 mt-2">
                        A <span className="green-text">Luna AI Receptionist</span>
                        &nbsp;will be purchased.
                    </p>
                    <p className="text-secondary lh-sm mb-3 mt-2">
                        This will increase your bill by   <span className="green-text"> $10</span>. per month plus   <span className="green-text"> $.20</span>. per minute from the time the call gets answered to the time the call gets transferred.
                    </p> */}



                </form >
                <div style={{ display: "none" }}>
                    <button ref={ref} onClick={(e) => {
                        e.preventDefault();
                        // validateOperator();
                        handleSubmit(onsubmit)()
                    }}>
                        {t("add")}</button>
                </div>
            </div >

        </>
    )
});

export default AddLuna
